import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import { ReactComponent as IconTick } from '@whitelabel/media/icons/flags/localeFlags/selected_flag.svg';
import { CURRENT_LOCALE, LANGUAGES_WITH_COUNTRY_SUFFIX } from '@whitelabel/rentalcover-shared/helpers/constants';
import messages from '@whitelabel/rentalcover-shared/helpers/messages/commonMsg';
import StyledModal from '@whitelabel/rentalcover-shared/styled/StyledModal';
import {
  StyledHeading,
  StyledLocaleLink,
  StyledLocaleListItem,
} from '@whitelabel/rentalcover-shared/styled/styledLocaleModal';
import { locales } from '@whitelabel/rentalcover-shared/helpers/site';
import FlagIcon from '@whitelabel/rentalcover-shared/components/FlagIcon';
import { useTypedRouter } from '../../helpers/hooks';
import { localePrefixRegex } from '../../helpers/constants';

export interface ILocaleModalProps {
  isOpen: boolean;
  toggle: () => void;
}

const LocaleModal = ({ isOpen, toggle }: ILocaleModalProps) => {
  const intl = useIntl();
  const { location } = useTypedRouter();

  const localesToShowInModal = Object.keys(locales).map((key) => ({
    code: key,
    name: locales[key].name,
    nameLocal: locales[key].nameLocal,
    xcode: locales[key].xcode,
  }));

  const getLocalePath = (localeCode: string) => {
    localStorage.setItem(CURRENT_LOCALE, localeCode);
    const newURL = location.pathname.replace(localePrefixRegex, `/${localeCode}`) + location.search + location.hash;
    return newURL;
  };

  const bodyContent = (
    <Row>
      {localesToShowInModal.map(({ code, name, nameLocal, xcode }) => {
        const localeIsActive = code === intl.locale;
        // Display name for EN and EN-US in language selection modal needs to be suffixed with (UK) and (US) respectively
        const languageName = LANGUAGES_WITH_COUNTRY_SUFFIX.includes(code) ? name : nameLocal;

        return (
          <Col xs={6} sm={4} key={code}>
            <StyledLocaleListItem>
              <StyledLocaleLink
                as={localeIsActive ? 'b' : 'a'}
                $active={localeIsActive}
                data-test-id="LocaleModal-item"
                data-analytics={`locale${name}`}
                href={localeIsActive ? undefined : getLocalePath(code)}
              >
                {localeIsActive ? <IconTick /> : <FlagIcon locale={xcode} />}
                {languageName}
              </StyledLocaleLink>
            </StyledLocaleListItem>
          </Col>
        );
      })}
    </Row>
  );

  return (
    <StyledModal
      isOpen={isOpen}
      header={<StyledHeading>{intl.formatMessage(messages.selectYourLanguage)}</StyledHeading>}
      body={bodyContent}
      toggle={toggle}
      backdrop
      centered
    />
  );
};

export default LocaleModal;
